import React from "react";
import PropTypes from "prop-types";

import { NavLink as Link } from "react-router-dom";

import { NavLink, NavItem, Nav } from "reactstrap";

import adminRoutes from "../../../../setup/routes/admin";
import userRoutes from "../../../../setup/routes/user";
import anonymousRoutes from "../../../../setup/routes/anonymous";
import AdminNav from "./AdminNav";

const LeftNav = ({
  isAuthenticated,
  isSuperAdmin,
  isAdmin,
  isGuide,
  onClickNavLink = (f) => f,
}) => {
  return (
    <Nav className="mr-auto" navbar>
      <NavItem>
        <NavLink
          onClick={onClickNavLink}
          to={anonymousRoutes.location.path}
          tag={Link}
        >
          Lieu
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          onClick={onClickNavLink}
          to={userRoutes.programs.path}
          tag={Link}
        >
          Programmation
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink
          onClick={onClickNavLink}
          to={userRoutes.supports.path}
          tag={Link}
        >
          Accompagnement
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          onClick={onClickNavLink}
          to={userRoutes.pricing.path}
          tag={Link}
        >
          Tarifs
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          onClick={onClickNavLink}
          to={anonymousRoutes.contactUs.path}
          tag={Link}
        >
          Contacter
        </NavLink>
      </NavItem>

      <NavItem>
        <NavLink
          onClick={onClickNavLink}
          to={userRoutes.services.path}
          tag={Link}
          className="text-primary"
        >
          Partenaires &amp; institutionnels
        </NavLink>
      </NavItem>

      <NavItem>
        <a
          href="https://www.helloasso.com/associations/la-ressourcerie-malakoff-humanis/formulaires/1"
          target="_blank"
          className="nav-link text-primary"
        >
          Soutenez-nous
        </a>
      </NavItem>
    </Nav>
  );
};

LeftNav.propTypes = {
  isAuthenticated: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isGuide: PropTypes.bool,
  isUser: PropTypes.bool,
  isSuperAdmin: PropTypes.bool,
  onClickNavLink: PropTypes.func,
};

export default LeftNav;
